'use client';

import type { PageConfigType } from '@/types';
import PurchaseButton from '@/components/PurchaseButton';
import { Box, Rating, Stack, Typography } from '@mui/material';
import Image from 'next/image';
const HeroSection = ({
  config
}: {
  config: PageConfigType;
}) => {
  return <Stack direction={{
    xs: 'column',
    md: 'row'
  }} spacing={4} alignItems="center" justifyContent="space-between" data-sentry-element="Stack" data-sentry-component="HeroSection" data-sentry-source-file="HeroSection.tsx">
      {/* Text */}
      <Box flex={1} data-sentry-element="Box" data-sentry-source-file="HeroSection.tsx">
        <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom data-sentry-element="Typography" data-sentry-source-file="HeroSection.tsx">
          {config.title}
        </Typography>
        <Typography variant="h6" component="h2" color="text.secondary" gutterBottom data-sentry-element="Typography" data-sentry-source-file="HeroSection.tsx">
          {config.description}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={1} sx={{
        mt: 2
      }} data-sentry-element="Stack" data-sentry-source-file="HeroSection.tsx">
          <Rating value={config.rating} readOnly data-sentry-element="Rating" data-sentry-source-file="HeroSection.tsx" />
          <Typography variant="body1" fontWeight="bold" data-sentry-element="Typography" data-sentry-source-file="HeroSection.tsx">
            {config.ratingStr}
          </Typography>
          {/* <Typography variant="body2" color="text.secondary">
              (1,200+ students)
            </Typography> */}
        </Stack>

        <Stack spacing={2} sx={{
        mt: 4
      }} data-sentry-element="Stack" data-sentry-source-file="HeroSection.tsx">
          <PurchaseButton price={0} productCode={config.code} data-sentry-element="PurchaseButton" data-sentry-source-file="HeroSection.tsx" />
        </Stack>
      </Box>

      {/* Image */}
      <Box flexShrink={0} sx={{
      bgcolor: 'background.paper',
      p: 2,
      borderRadius: 4,
      boxShadow: 3,
      textAlign: 'center',
      maxWidth: 300,
      width: '100%'
    }} data-sentry-element="Box" data-sentry-source-file="HeroSection.tsx">
        <Image src={config.image.url} alt={config.image.alt} width={300} height={300} style={{
        width: '100%',
        height: 'auto',
        objectFit: 'contain'
      }} priority data-sentry-element="Image" data-sentry-source-file="HeroSection.tsx" />
      </Box>
    </Stack>;
};
export default HeroSection;